import { logger as globalLogger } from '@empathy/logger';

export const logger = globalLogger.child('%cEmpathyX',
  'background-color:#c50953;color:#ffffff;border-radius:3px;padding:3px 10px;font-weight:bold');
